import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({

  unauthorizedContainer: {
    flexGrow: 1
  }

}));
